import styled from "styled-components";

export const StyledFilterContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;
